// According to Google FAQ structured data docs (https://developers.google.com/search/docs/appearance/structured-data/faqpage)
// Answer text may contain limited HTML. We sanitize to keep only allowed tags
// and neutralize anything potentially unsafe (e.g., script tags, event handlers)
// while also escaping closing </script to avoid breaking out of the JSON-LD script block.
const ALLOWED_TAGS = new Set([
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "br",
  "ol",
  "ul",
  "li",
  "a",
  "p",
  "div",
  "b",
  "strong",
  "i",
  "em",
])

export const sanitizeForJsonLd = (html: string): string => {
  if (!html || typeof html !== "string") {
    return ""
  }
  let cleaned = html
  // Remove script & style blocks entirely
  cleaned = cleaned.replace(/<script[\s\S]*?<\/script>/gi, "")
  cleaned = cleaned.replace(/<style[\s\S]*?<\/style>/gi, "")
  // Strip disallowed tags but keep inner text (naive approach for paired tags)
  cleaned = cleaned.replace(/<\/?([a-z0-9-]+)(\s[^>]*)?>/gi, (match, tag) => {
    const t = (tag as string).toLowerCase()
    if (!ALLOWED_TAGS.has(t)) {
      return "" // drop tag entirely
    }
    // For allowed tags, remove on* handlers & javascript: href/src
    let safe = match
    // Remove event handlers
    safe = safe.replace(/\s+on[a-z]+\s*=\s*"[^"]*"/gi, "")
    safe = safe.replace(/\s+on[a-z]+\s*=\s*'[^']*'/gi, "")
    // Neutralize javascript: URIs in href/src
    safe = safe.replace(/(href|src)\s*=\s*(['"])javascript:[^'"#]*\2/gi, "$1=\"#\"")
    return safe
  })
  // Collapse excessive whitespace
  cleaned = cleaned.replace(/\s+/g, " ").trim()
  // Escape closing </script to prevent breaking out of JSON-LD script tag
  cleaned = cleaned.replace(/<\/script/gi, "<\\/script")
  return cleaned
}
